module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center"
  }, [_c('span', {
    staticClass: "title font-weight-600"
  }, [_vm._v("Discover")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/search.svg"),
      "width": 20,
      "height": 20
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll mt-3"
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "discover__category horizontal-scroll__item display-flex justify-center align-center mr-2 px-4",
      class: {
        'bg-black text-white': item.active
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "discover__play"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8 discover__play__content",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'PlayerMobile'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/play.svg"),
      "width": 42,
      "height": 42
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "discover__play-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "discover__play-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-15 my-5 text-center"
  }, [_vm._v("\n    Swipe left for more, swipe right to save\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover__type display-flex gap-8 align-center full-width my-3"
  }, [_c('div', {
    staticClass: "discover__type__item bg-black text-white display-flex justify-center align-center"
  }, [_vm._v("\n      Trending\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "discover__type__item display-flex justify-center align-center"
  }, [_vm._v("\n      New\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "discover__type__item display-flex justify-center align-center"
  }, [_vm._v("\n      Popular\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "discover__play__image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/discoverm.png"),
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "absolute discover__play__btn display-flex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "discover__play__btn--previous display-flex align-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/player_previous.svg"),
      "width": "20px",
      "height": "20px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "discover__play__btn--next display-flex align-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/player_next.svg"),
      "width": "20px",
      "height": "20px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-18 text-black font-weight-500"
  }, [_vm._v("\n          Wonder Where We Land\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 text-gray font-weight-500"
  }, [_vm._v("Sbtkrt")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61fdb72e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/discover.vue
// module id = 1746
// module chunks = 180